/**
 * Mobile product bar (snippets/product-mobile-bar.liquid).
 *
 * The bar never submits anything itself: it checks the option radios of the real product form (or clicks the
 * popover values in dropdown mode), listens to the theme's bubbling "variant:changed" event to stay in sync, and
 * clicks the real add to cart button. It also filters the mobile image stack to the selected color.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-pm-bar]');
  if (!bar) return;

  var section = bar.closest('[data-section-type="product"]') || document;
  var jsonElement = section.querySelector('[data-product-json]');
  if (!jsonElement) return;

  var productJson;
  try {
    productJson = JSON.parse(jsonElement.textContent);
  } catch (error) {
    return;
  }

  var product = productJson.product;
  var variants = product.variants || [];
  var colorPosition = parseInt(bar.getAttribute('data-color-position'), 10) || 0;
  var otherPosition = parseInt(bar.getAttribute('data-other-position'), 10) || 0;
  var sizeChosen = bar.getAttribute('data-size-chosen') === 'true';
  var labels = {
    select: bar.getAttribute('data-select-label'),
    add: bar.getAttribute('data-add-label'),
    soldOut: bar.getAttribute('data-sold-out-label'),
    unavailable: bar.getAttribute('data-unavailable-label'),
    notify: 'Notify me'
  };

  var stack = section.querySelector('[data-pm-stack]');
  var priceElement = bar.querySelector('[data-pm-price]');
  var colorNameElement = bar.querySelector('[data-pm-color-name]');
  var colorButtons = Array.prototype.slice.call(bar.querySelectorAll('[data-pm-color]'));
  var sizeLabelElement = bar.querySelector('[data-pm-size-label]');
  var openSheetButton = bar.querySelector('[data-pm-open-sheet]');
  var addButton = bar.querySelector('[data-pm-add]');
  var sheet = document.querySelector('[data-pm-sheet]');
  var sizeButtons = sheet ? Array.prototype.slice.call(sheet.querySelectorAll('[data-pm-size]')) : [];
  var mobileQuery = window.matchMedia('(max-width: 640px)');

  var currentVariant = findVariantById(productJson.selected_variant_id) || variants[0] || null;
  var currentColor = currentVariant && colorPosition ? currentVariant['option' + colorPosition] : null;
  var sheetOpenedFromAdd = false;
  var lastFocused = null;

  // The sheet is moved to <body> so that it isn't clipped or stacked under any section container
  if (sheet && sheet.parentNode !== document.body) {
    document.body.appendChild(sheet);
  }

  document.body.classList.add('pm-has-bar');

  function findVariantById(id) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  function findVariant(color, other) {
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      if (colorPosition && variant['option' + colorPosition] !== color) continue;
      if (otherPosition && variant['option' + otherPosition] !== other) continue;
      return variant;
    }
    return null;
  }

  /* ------------------------------------------------------------------------------------------------------------------
   * Selecting options in the real product form
   * ------------------------------------------------------------------------------------------------------------------ */

  function selectOption(position, value) {
    var radios = section.querySelectorAll('.ProductForm__Option input[type="radio"][data-option-position="' + position + '"]');

    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }

    // Dropdown selector mode renders popover values instead of radios
    var popoverValues = document.querySelectorAll('.Popover__Value[data-option-position="' + position + '"]');

    for (var j = 0; j < popoverValues.length; j++) {
      if (popoverValues[j].getAttribute('data-value') === value) {
        if (!popoverValues[j].classList.contains('is-selected')) {
          popoverValues[j].click();
        }
        return true;
      }
    }

    return false;
  }

  /* ------------------------------------------------------------------------------------------------------------------
   * Color image filter: every color owns the images from its first variant image up to the next color's first image.
   * Images outside of those ranges (shared lifestyle shots) are always shown.
   * ------------------------------------------------------------------------------------------------------------------ */

  var colorRanges = (function () {
    if (!stack || !colorPosition) return null;

    var starts = {};

    variants.forEach(function (variant) {
      var color = variant['option' + colorPosition];
      var media = variant.featured_media;

      if (media && media.position && (!starts[color] || media.position < starts[color])) {
        starts[color] = media.position;
      }
    });

    var colors = Object.keys(starts);
    var allColors = {};

    variants.forEach(function (variant) {
      allColors[variant['option' + colorPosition]] = true;
    });

    // Only filter when every color has its own, distinct first image
    if (colors.length < 2 || colors.length !== Object.keys(allColors).length) return null;

    var sorted = colors.map(function (color) {
      return { color: color, start: starts[color] };
    }).sort(function (a, b) {
      return a.start - b.start;
    });

    var minGap = Infinity;

    for (var i = 1; i < sorted.length; i++) {
      var gap = sorted[i].start - sorted[i - 1].start;
      if (gap <= 0) return null;
      minGap = Math.min(minGap, gap);
    }

    var ranges = {};

    sorted.forEach(function (entry, index) {
      var end = index < sorted.length - 1 ? sorted[index + 1].start - 1 : entry.start + minGap - 1;
      ranges[entry.color] = { start: entry.start, end: end };
    });

    return ranges;
  })();

  function colorForPosition(position) {
    for (var color in colorRanges) {
      if (position >= colorRanges[color].start && position <= colorRanges[color].end) return color;
    }
    return null;
  }

  function filterImages(color, scrollToTop) {
    if (!colorRanges || !colorRanges[color]) return;

    Array.prototype.forEach.call(stack.querySelectorAll('[data-media-position]'), function (item) {
      var owner = colorForPosition(parseInt(item.getAttribute('data-media-position'), 10));
      item.hidden = owner !== null && owner !== color;
    });

    if (scrollToTop && mobileQuery.matches) {
      var top = stack.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      if (window.pageYOffset > top) {
        window.scrollTo({ top: Math.max(top, 0), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      }
    }
  }

  /* ------------------------------------------------------------------------------------------------------------------
   * Rendering
   * ------------------------------------------------------------------------------------------------------------------ */

  function hasBackInStock() {
    return !!section.querySelector('[data-back-in-stock]');
  }

  function render() {
    var variant = currentVariant;

    // Price: the theme has already updated the main price list before "variant:changed" fires
    var metaPrice = section.querySelector('.ProductMeta__PriceList');
    if (priceElement && metaPrice && variant) {
      priceElement.innerHTML = metaPrice.innerHTML;
    }

    // Color
    if (currentColor !== null) {
      colorButtons.forEach(function (button) {
        button.setAttribute('aria-checked', button.getAttribute('data-pm-color') === currentColor ? 'true' : 'false');
      });

      if (colorNameElement) colorNameElement.textContent = currentColor;
    }

    // Size label + availability for the current color
    if (sizeLabelElement) {
      sizeLabelElement.textContent = sizeChosen && variant ? variant['option' + otherPosition] : labels.select;
      openSheetButton.classList.toggle('is-placeholder', !sizeChosen);
    }

    sizeButtons.forEach(function (button) {
      var value = button.getAttribute('data-pm-size');
      var match = findVariant(currentColor, value);
      var soldOut = !match || !match.available;
      var selected = sizeChosen && variant && variant['option' + otherPosition] === value;
      var status = button.querySelector('[data-pm-size-status]');

      button.classList.toggle('is-soldOut', soldOut);
      button.classList.toggle('is-selected', !!selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (status) status.textContent = soldOut ? labels.soldOut : '';
    });

    // Add button
    var label = labels.add;
    var disabled = false;
    var state = 'add';
    var allSoldOut = sizeButtons.length > 0 && sizeButtons.every(function (button) {
      return button.classList.contains('is-soldOut');
    });

    if (!sizeChosen) {
      state = 'select';
      // Still opens the sheet, so a size can be picked to get notified
      if (allSoldOut) label = labels.soldOut;
    } else if (!variant) {
      label = labels.unavailable;
      disabled = true;
      state = 'unavailable';
    } else if (!variant.available) {
      if (hasBackInStock()) {
        label = labels.notify;
        state = 'notify';
      } else {
        label = labels.soldOut;
        disabled = true;
        state = 'soldout';
      }
    }

    addButton.textContent = label;
    addButton.disabled = disabled;
    addButton.setAttribute('data-state', state);
    addButton.classList.toggle('Button--primary', state === 'add' || (state === 'select' && !allSoldOut));
    addButton.classList.toggle('Button--secondary', !(state === 'add' || (state === 'select' && !allSoldOut)));

    updateBarHeight();
  }

  /* ------------------------------------------------------------------------------------------------------------------
   * Size sheet
   * ------------------------------------------------------------------------------------------------------------------ */

  function onSheetKeydown(event) {
    if (event.key === 'Escape') {
      closeSheet();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = Array.prototype.filter.call(sheet.querySelectorAll('button'), function (element) {
      return !element.disabled && element.offsetParent !== null;
    });

    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openSheet(fromAdd) {
    if (!sheet) return;

    sheetOpenedFromAdd = !!fromAdd;
    lastFocused = document.activeElement;
    render();

    sheet.hidden = false;
    document.documentElement.classList.add('pm-sheet-open');
    if (openSheetButton) openSheetButton.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(function () {
      sheet.classList.add('is-open');

      var target = sheet.querySelector('.PMSheet__Option.is-selected') || sheet.querySelector('.PMSheet__Option');
      (target || sheet.querySelector('.PMSheet__Panel')).focus({ preventScroll: true });
    });

    document.addEventListener('keydown', onSheetKeydown);
  }

  function closeSheet() {
    if (!sheet || sheet.hidden) return;

    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('pm-sheet-open');
    if (openSheetButton) openSheetButton.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onSheetKeydown);

    var hide = function () {
      sheet.hidden = true;
    };

    if (prefersReducedMotion()) {
      hide();
    } else {
      setTimeout(hide, 250);
    }

    if (lastFocused && lastFocused.focus) {
      lastFocused.focus({ preventScroll: true });
    }
  }

  /* ------------------------------------------------------------------------------------------------------------------
   * Actions
   * ------------------------------------------------------------------------------------------------------------------ */

  function addToCart() {
    var realButton = section.querySelector('.ProductForm__AddToCart');
    if (realButton && !realButton.disabled) {
      realButton.click();
    }
  }

  function goToBackInStock() {
    var target = section.querySelector('[data-back-in-stock]');
    if (!target) return;

    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 20;
    window.scrollTo({ top: Math.max(top, 0), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });

    var input = target.querySelector('input[type="email"]');
    if (input) {
      setTimeout(function () {
        input.focus({ preventScroll: true });
      }, prefersReducedMotion() ? 0 : 400);
    }
  }

  bar.addEventListener('click', function (event) {
    var colorButton = event.target.closest('[data-pm-color]');

    if (colorButton) {
      var color = colorButton.getAttribute('data-pm-color');
      if (color !== currentColor) {
        selectOption(colorPosition, color);
      }
      return;
    }

    if (event.target.closest('[data-pm-open-sheet]')) {
      openSheet(false);
      return;
    }

    if (event.target.closest('[data-pm-add]')) {
      var state = addButton.getAttribute('data-state');

      if (state === 'select') {
        openSheet(true);
      } else if (state === 'add') {
        addToCart();
      } else if (state === 'notify') {
        goToBackInStock();
      }
    }
  });

  // Arrow keys move between color thumbnails (radiogroup pattern)
  bar.addEventListener('keydown', function (event) {
    var colorButton = event.target.closest('[data-pm-color]');
    if (!colorButton || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(event.key) === -1) return;

    event.preventDefault();

    var index = colorButtons.indexOf(colorButton);
    var delta = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
    var next = colorButtons[(index + delta + colorButtons.length) % colorButtons.length];

    next.focus();
    next.click();
  });

  if (sheet) {
    sheet.addEventListener('click', function (event) {
      if (event.target.closest('[data-pm-close-sheet]')) {
        closeSheet();
        return;
      }

      if (event.target.closest('[data-action="open-modal"]')) {
        closeSheet();
        return;
      }

      var sizeButton = event.target.closest('[data-pm-size]');
      if (!sizeButton) return;

      var value = sizeButton.getAttribute('data-pm-size');
      var addAfter = sheetOpenedFromAdd;

      sizeChosen = true;
      selectOption(otherPosition, value);
      render();
      closeSheet();

      // Tapping "Add to bag" without a size opens the sheet: picking an available size completes that add
      if (addAfter && currentVariant && currentVariant.available) {
        addToCart();
      }
    });
  }

  section.addEventListener('variant:changed', function (event) {
    var previousColor = currentColor;

    currentVariant = event.detail ? event.detail.variant : null;

    if (currentVariant && colorPosition) {
      currentColor = currentVariant['option' + colorPosition];
    } else if (colorPosition) {
      // The combination doesn't exist: read the color from the checked radio / selected popover value
      var checked = section.querySelector('.ProductForm__Option input[type="radio"][data-option-position="' + colorPosition + '"]:checked');
      if (checked) currentColor = checked.value;
    }

    render();

    if (currentColor !== previousColor) {
      filterImages(currentColor, true);
    }
  });

  /* ------------------------------------------------------------------------------------------------------------------
   * Layout helpers
   * ------------------------------------------------------------------------------------------------------------------ */

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function headerOffset() {
    var header = document.querySelector('.Header--sticky, [data-section-type="header"] .Header');
    if (!header) return 0;

    var style = window.getComputedStyle(header);
    return style.position === 'fixed' || style.position === 'sticky' ? header.offsetHeight : 0;
  }

  // The bar lives in a slot above the Shop Pay button. It stays fixed to the bottom of the screen until the slot
  // scrolls into view, then docks into the page (like a sticky footer). The slot keeps the bar's height reserved
  // while it is fixed, so docking doesn't shift the layout.
  var dock = section.querySelector('[data-pm-dock]');
  var fixedBarHeight = 0;
  var docked = false;
  var dockFrame = null;

  if (dock && bar.parentNode !== dock) {
    dock.appendChild(bar);
  }

  function updateBarHeight() {
    if (docked) return;

    fixedBarHeight = bar.offsetHeight;
    document.documentElement.style.setProperty('--pm-bar-height', fixedBarHeight + 'px');
    updateDock();
  }

  function updateDock() {
    dockFrame = null;
    if (!dock) return;

    var shouldDock = mobileQuery.matches && dock.getBoundingClientRect().top + fixedBarHeight <= window.innerHeight;

    if (shouldDock === docked) return;

    docked = shouldDock;
    bar.classList.toggle('PMBar--docked', docked);
    document.body.classList.toggle('pm-bar-docked', docked);

    if (!docked) {
      fixedBarHeight = bar.offsetHeight;
      document.documentElement.style.setProperty('--pm-bar-height', fixedBarHeight + 'px');
    }
  }

  function requestDockUpdate() {
    if (!dockFrame) dockFrame = window.requestAnimationFrame(updateDock);
  }

  window.addEventListener('scroll', requestDockUpdate, { passive: true });
  window.addEventListener('resize', requestDockUpdate);

  if (window.ResizeObserver) {
    new ResizeObserver(updateBarHeight).observe(bar);
  } else {
    window.addEventListener('resize', updateBarHeight);
  }

  updateBarHeight();

  mobileQuery.addListener(function (event) {
    if (!event.matches) closeSheet();
  });

  filterImages(currentColor, false);
  render();
})();
